import React from "react";
import PT from "prop-types";
import * as S from "./Gallery.styled";
import { generateUrl } from "@/utils/cloudinary";
import { useImagesGallery } from "@/hooks/useImagesGallery";

const InteriorGallery = (props) => {
  const baseOpenGallery = useImagesGallery();
  const openGallery = (activeIndex) => {
    baseOpenGallery({
      images: props.photos.map((source) => generateUrl(source)),
      activeIndex,
    });
  };
  return (
    <S.Wrap>
      {props.photos.map((photo, idx) => (
        <S.Item role="button" onClick={() => openGallery(idx)} key={photo}>
          <img alt={props.defaultAltText} src={generateUrl(photo)} />
        </S.Item>
      ))}
    </S.Wrap>
  );
};
InteriorGallery.propTypes = {
  photos: PT.array.isRequired,
};
export default InteriorGallery;
